import React, { FC } from 'react';
import {
    ChannelProgramsSelection,
    TvChannel,
    TvChannelProgram,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { ReadonlySignal, Route, RouterLocation } from '@funtech-int/rival';
import classnames from 'classnames';

import { Carousel } from '../Carousel/Carousel';
import * as Card from '../Card';

import { SelectionTitle } from './_SelectionTitle';
import styles from './_Selection.module.css';

interface ChannelProgramsSelectionProps {
    selection: ChannelProgramsSelection;
    location: RouterLocation<any, any>;
    channelRoute: Route<any, any, any>;
    timeSignal: ReadonlySignal<number>;
    className?: string;
    startContent(contentId: string): void;
    onHeaderClick?(): void;
    onShowAllClick?(): void;
    onCardShow?: (item: TvChannel, position: number, program?: TvChannelProgram) => void;
    onCardClick?: (item: TvChannel, position: number, program?: TvChannelProgram) => void;
}

export const ChannelPrograms: FC<ChannelProgramsSelectionProps> = ({
    selection,
    location,
    channelRoute,
    timeSignal,
    className,
    startContent,
    onHeaderClick,
    onShowAllClick,
    onCardShow,
    onCardClick,
}) => (
    <div className={classnames(styles.root, className)}>
        <SelectionTitle
            title={selection.title}
            location={location}
            onClick={onHeaderClick}
            iconClassName={styles.titleLinkIcon}
        />
        <Carousel>
            {selection.items.map((item, position) => {
                const hanleCardShow = (program?: TvChannelProgram) => {
                    onCardShow?.(item, position, program);
                };

                const handleCardClick = (program?: TvChannelProgram) => {
                    onCardClick?.(item, position, program);
                };

                return (
                    <Card.ChannelProgram
                        key={item.contentId}
                        channel={item}
                        location={channelRoute()}
                        timeSignal={timeSignal}
                        startContent={startContent}
                        onShow={hanleCardShow}
                        onClick={handleCardClick}
                    />
                );
            })}
            {selection.hasMore && <Card.ShowAll location={location} onClick={onShowAllClick} />}
        </Carousel>
    </div>
);
